import { render, staticRenderFns } from "./BaseErrorSoundButton.vue?vue&type=template&id=40d95f50&"
import script from "./BaseErrorSoundButton.vue?vue&type=script&lang=ts&"
export * from "./BaseErrorSoundButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports